export default "/fonts/UkNumberPlate.eot?72e0f35b00aa86f58baa1777751b1d98";